import React, { Component } from "react";
import { formatNumber, formatPercentage } from "../../utils/numeral";
import _ from "lodash";

class CompleteFunnelGraph extends Component {
  constructor() {
    super();

    this.state = {
      html: "",
      showVideoPlays: false
    };

    this.mountFunnel = this.mountFunnel.bind(this);
    this.toggleVideoPlays = this.toggleVideoPlays.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    this.mountFunnel(nextProps);
  }
  toggleVideoPlays() {
    this.props.toggleVideoPlay(!this.state.showVideoPlays);
    this.setState(
      {
        showVideoPlays: !this.state.showVideoPlays
      },
      () => {
        this.mountFunnel(this.props);
      }
    );
  }
  mountFunnel(props) {
    let { dataForGraph } = props;
    let { showVideoPlays } = this.state;
    if (!dataForGraph) {
      return false;
    }
    var html = [];
    var data = dataForGraph;

    data.forEach((element, index) => {
      if (element.type === "line") {
        html.push(
          <div
            key={index}
            className={`customFunnel__group customFunnel__group-${index} ${
              element.label === "Player tocar video"
                ? "customFunnel__group--hidden"
                : ""
            }`}
            style={showVideoPlays === true ? { display: "flex" } : {}}
          >
            <div className="customFunnel__label">
              {element.label === "Plays" ? (
                  <span>{element.label} {`(${formatPercentage(element.rate)})`}</span>
              ) : (
                <span>
                  {" "}
                  {element.label}{" "}
                  {_.isNumber(element.rate)
                    ? `(${formatPercentage(element.rate)})`
                    : element.rate}
                </span>
              )}
            </div>
            <div className="customFunnel__funil">
              <div
                className="customFunnel__graph-wrapper"
                style={element.color ? { backgroundColor: element.color } : {}}
              >
                <div className="customFunnel__graph-group">
                  <div
                    className="customFunnel__graph-line"
                    style={
                      element.color ? { backgroundColor: element.color } : {}
                    }
                  >
                    <div className="customFunnel__graph-text">
                      <strong className="customFunnel__graph-text__value">
                        {_.isNumber(element.value)
                          ? formatNumber(element.value)
                          : element.value}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      } else if (element.type === "line-plus") {
        html.push(
          <div
            key={index}
            className={`customFunnel__group customFunnel__group-${index}`}
          >
            <div className="customFunnel__label">
              {element.rateTarget === null ? (
                <span>
                  {element.label} ({element.rate})
                </span>
              ) : (
                <span>
                  {element.label} (<b className="text-orange">{element.rate}</b>{" "}
                  / <b className="text-purple">{element.rateTarget}</b>)
                </span>
              )}
            </div>
            <div className="customFunnel__funil">
              <div
                className="customFunnel__graph-wrapper"
                style={element.color ? { backgroundColor: element.color } : {}}
              >
                <div className="customFunnel__graph-group">
                  <div
                    className="customFunnel__graph-line"
                    style={
                      element.color ? { backgroundColor: element.color } : {}
                    }
                  >
                    <div className="customFunnel__graph-text">
                      <strong className="customFunnel__graph-text__value">
                        {element.valueTarget === null ? (
                          <b>{element.value}</b>
                        ) : (
                          <span>
                            <b className="text-orange">{element.value}</b>
                            <small className="text-purple">
                              ({element.valueTarget})
                            </small>
                          </span>
                        )}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      } else if (element.type === "group") {
        let group;
        if (element.group.length > 0) {
          group = (
            <div
              key={index}
              className={`customFunnel__group customFunnel__group-${index}`}
            >
              <div className="customFunnel__label customFunnel__label--align-top">
                <span>{element.label}</span>
              </div>
              <div className="customFunnel__funil">
                <div className="customFunnel__graph-wrapper customFunnel__graph-wrapper--big customFunnel__graph-wrapper--no-clip customFunnel__graph-wrapper--borders">
                  {element.group.map((group, index) => {
                    if (group.label === "(direto)") {
                      return false;
                    }
                    return (
                      <div key={index} className="customFunnel__graph-group">
                        {/* {!(element.group.length === 1 && element.group[0].label === '(direto)') &&} */}
                        <div
                          className="customFunnel__graph-line"
                          style={{ backgroundColor: "#42b3f4" }}
                        >
                          <div className="customFunnel__graph-text">
                            <strong className="customFunnel__graph-text__value">
                              {group.value > 0 ? group.value : "-"}
                            </strong>
                            <span className="customFunnel__graph-text__label">
                              {group.label}
                            </span>
                          </div>
                        </div>
                        <div className="customFunnel__graph-line">
                          {group.childrens.map((cta, index) => (
                            <div
                              key={index}
                              className="customFunnel__graph-text"
                            >
                              <strong className="customFunnel__graph-text__value">
                                {cta.value}
                              </strong>
                              <span className="customFunnel__graph-text__label">
                                {cta.label}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
          html.push(group);
        }
      } else if (element.type === "cta-group") {
        let group = (
          <div
            key={index}
            className={`customFunnel__group customFunnel__group-${index}`}
          >
            <div className="customFunnel__label">
              <span>
                {element.label} {`(${formatPercentage(element.rate)})`}
              </span>
            </div>
            <div className="customFunnel__funil">
              <div
                className="customFunnel__graph-wrapper customFunnel__graph-wrapper--big"
                style={element.color ? { backgroundColor: element.color } : {}}
              >
                <div className="customFunnel__graph-group">
                  <div
                    className="customFunnel__graph-line"
                    style={
                      element.color ? { backgroundColor: element.color } : {}
                    }
                  >
                    {element.values.map((lineObj, index) => (
                      <div key={index} className="customFunnel__graph-text">
                        <strong className="customFunnel__graph-text__value">
                          {lineObj.value}
                        </strong>
                        <span className="customFunnel__graph-text__label">
                          {lineObj.label}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div
                    className="customFunnel__graph-line"
                    style={
                      element.color ? { backgroundColor: element.color } : {}
                    }
                  >
                    <div className="customFunnel__graph-text">
                      <strong className="customFunnel__graph-text__value">
                        {formatNumber(element.total)}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
        html.push(group);
      } else if (element.type === "nav-group") {
        let group = (
          <div
            key={index}
            className={`customFunnel__group customFunnel__group-${index}`}
          >
            <div className="customFunnel__label">
              <span>
                {element.label} {`(${formatPercentage(element.rate)})`}
              </span>
            </div>
            <div className="customFunnel__funil">
              <div
                className="customFunnel__graph-wrapper"
                style={element.color ? { backgroundColor: element.color } : {}}
              >
                <div className="customFunnel__graph-group">
                  <div className="customFunnel__graph-line">
                    {element.values.map((lineObj, index) => (
                      <div key={index} className="customFunnel__graph-text">
                        <strong className="customFunnel__graph-text__value">
                          {lineObj.value}
                        </strong>
                        <span className="customFunnel__graph-text__label">
                          {lineObj.label}{" "}
                          {`(${formatPercentage(lineObj.rate, "0%")})`}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
        html.push(group);
      } else {
        return false;
      }
    });
    this.setState({
      html
    });
  }
  render() {
    let { funnelType } = this.props;
    return (
      <div
        className={`customFunnel ${funnelType} ${funnelType}--${
          this.state.showVideoPlays
        }`}
      >
        {this.state.html}
      </div>
      // <div className='customFunnel'>
      //   <div className='customFunnel__group customFunnel__group-1'>

      //     <div className='customFunnel__label'>
      //       <span>Conversão</span>
      //     </div>

      //     <div className='customFunnel__funil'>
      //       <div className='customFunnel__graph-group'>
      //         <div className='customFunnel__graph-line'>
      //           <div className='customFunnel__graph-text'>
      //             <strong className='customFunnel__graph-text__value'>200</strong>
      //             <span className='customFunnel__graph-text__label'>nav 1</span>
      //           </div>
      //         </div>
      //         <div className='customFunnel__graph-line'>
      //           <div className='customFunnel__graph-text'>
      //             <strong className='customFunnel__graph-text__value'>100</strong>
      //             <span className='customFunnel__graph-text__label'>botao 1</span>
      //           </div>
      //           <div className='customFunnel__graph-text'>
      //             <strong className='customFunnel__graph-text__value'>100</strong>
      //             <span className='customFunnel__graph-text__label'>botao 2</span>
      //           </div>
      //         </div>
      //       </div>
      //       <div className='customFunnel__graph-group'>
      //         <div className='customFunnel__graph-line'>
      //           <div className='customFunnel__graph-text'>
      //             <strong className='customFunnel__graph-text__value'>200</strong>
      //             <span className='customFunnel__graph-text__label'>nav 2</span>
      //           </div>
      //         </div>
      //         <div className='customFunnel__graph-line'>
      //           <div className='customFunnel__graph-text'>
      //             <strong className='customFunnel__graph-text__value'>100</strong>
      //             <span className='customFunnel__graph-text__label'>botao 1</span>
      //           </div>
      //           <div className='customFunnel__graph-text'>
      //             <strong className='customFunnel__graph-text__value'>100</strong>
      //             <span className='customFunnel__graph-text__label'>botao 2</span>
      //           </div>
      //           <div className='customFunnel__graph-text'>
      //             <strong className='customFunnel__graph-text__value'>100</strong>
      //             <span className='customFunnel__graph-text__label'>botao 3</span>
      //           </div>
      //         </div>
      //       </div>
      //     </div>

      //   </div>

      //   <div className='customFunnel__group customFunnel__group-2'>
      //     <div className='customFunnel__label'>
      //       <span>Recomendações</span>
      //     </div>

      //     <div className='customFunnel__funil'>
      //       <div className='customFunnel__graph-group'>
      //         <div className='customFunnel__graph-line'>
      //           <div className='customFunnel__graph-text'>
      //             <strong className='customFunnel__graph-text__value'>200</strong>
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </div>
    );
  }
}

export default CompleteFunnelGraph;



// WEBPACK FOOTER //
// ./src/components/charts/CompleteFunnelGraph.js